import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

function Profile() {


    const navigate = useNavigate()
    // hooks

    // useState , useEffect

    const [first, setfirst] = useState({})



    // useEffect working like componentDidMount
    useEffect(() => {
        getProfile()

        return () => { }
    }, [])

    const logout = () => {
        localStorage.removeItem("authToken");
        // localStorage.removeItem("userData");
        toast.success("Logout successfully");
        navigate("/login");
    };
    const getProfile = async () => {



        try {
            const getToken = localStorage.getItem("authToken");



            const response = await fetch("http://localhost:3022/users/getprofile", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
                    Authorization: `Bearer ${getToken}`,
                },
            });


            if (response.ok) {
                const data = await response.json(); // Response ko JSON me convert kare

                setfirst(data?.user)
                console.log("User data:", data);
            } else {
                console.log("error:");
                // Login failed
                // setError(data.message || "Login failed");
            }
        } catch (err) {
            // setError("Something went wrong. Please try again.");
        }
    }

    return (
        <div>


            <Link to="/" >Home</Link>

            <p> {first?.name}</p>
            <p> {first?.number}</p>
            <p> {first?.email}</p>
            <p> {first?.city}</p>
            <p> {first?.address}</p>
            <p> {first?.name}</p>

            <button onClick={logout}>Logout</button>

        </div>
    )
}

export default Profile